import wixWindow from 'wix-window';

$w.onReady(function () {});